module.exports = __webpack_public_path__ + "static/media/Jaxani_Veg_Food_logo.a7b1b355.png";